import { client } from '../http';

async function fetchBudgetCategoryQuestions() {
  const response = await client.get('/api/investigator/questions/budget-category');
  return response.data;
}

async function fetchIncomeQuestions() {
  const response = await client.get('/api/investigator/onboarding/questions/income');
  return response.data;
}

async function fetchExpenseQuestions() {
  const response = await client.get('/api/investigator/onboarding/questions/expense');
  return response.data;
}

async function fetchBugRules() {
  const response = await client.get('/api/bug-manager');
  return response.data;
}

async function answerTransactionCategoryQuestion({ transactionId, budgetCategory }) {
  return await client.post('/api/investigator/answers/budget-category', { transactionId, budgetCategory });
}

async function answerPredictedIncomeQuestion({ budgetDate, amount }) {
  return await client.post('/api/investigator/answers/income-prediction', { budgetDate, amount });
}

export default {
  fetchBudgetCategoryQuestions,
  fetchIncomeQuestions,
  fetchExpenseQuestions,
  fetchBugRules,
  answerTransactionCategoryQuestion,
  answerPredictedIncomeQuestion,
};
